import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { MdrSecurityTelemetryExclusionsGridDataProvider } from '../dataProvider/MdrSecurityTelemetryExclusionsGridDataProvider';

export class MdrSecurityTelemetryExclusionsGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MdrSecurityTelemetryExclusionsGridDataProvider);
  }
}
